import { BitePlatform } from '@biteinc/enums';

import { GCNAlertView } from '~/app/js/views/gcn_alert_view';

const missingIntegrationMessages = [
  'No matching stored value integration found for this system.',
  // A loyalty integration migrated to campus card mid-checkout surfaces through the
  // loyalty routes with this message; the guest needs the same refresh to pick up the
  // new campus-card configuration.
  'No loyalty integration found for this location.',
];

function getErrorMessage(error: unknown): string | undefined {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error && 'message' in error) {
    const message = error.message;
    return typeof message === 'string' ? message : undefined;
  }

  return undefined;
}

export function showStoredValueIntegrationRefreshPromptIfNeeded(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (
    !message ||
    !missingIntegrationMessages.includes(message) ||
    !window.isFlash ||
    window.platform !== BitePlatform.Flash
  ) {
    return false;
  }

  gcn.menuView.dismissSpinner();
  gcn.menuView.dismissStablePopup();
  gcn.menuView.showModalPopup(
    new GCNAlertView({
      text: 'This checkout is using an older gift card setup. Refresh checkout to continue with the latest campus card settings.',
      okText: 'Refresh Checkout',
      okCallback: () => {
        window.location.reload();
      },
    }),
  );

  return true;
}
